export const fetch = (mockData, time = 100) =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockData);
    }, time);
  });

// For å teste feilmelding: Endre en av fetch-ene under til 'fail'.
export const fail = (mockData, time = 100) =>
  new Promise((resolve, reject) => {
    setTimeout(() => {
      // eslint-disable-next-line
      reject({ response: { status: 403 } });
    }, time);
  });
